module.exports = __webpack_public_path__ + "assets/checked2.fe673e53.svg";